import React from 'react';
import { Button, Icon, Table, Header, Segment, Popup, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema studenata.</p>;
const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema studenata.</p>;

export default class AllStudents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filterData: [],
            studyPrograms: [],

            showFiltersOnButton: false,
            showFilterMode: false,
            loading: true,

        };
        this.getStudents = this.getStudents.bind(this);
        this.filtersOff = this.filtersOff.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        this.getStudents();
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    getStudents() {
        let obj = {};
        axios.post('students/filter-students/false', { ...obj })
            .then(res => {
                const dataa = res.data;
                this.setState({ data: dataa, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.data;
    }

    getFilterData(firstName, lastName, index) {
        this.setState({ loading: true });
        let docFilter = {};

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (index) docFilter = { ...docFilter, index };

        if (this.state.showFilterMode) {
            if (firstName || lastName) {
                this.setState({ showFiltersOnButton: true, showFilterMode: false });
            } else {
                toast('Morate unijeti po čemu želite filtrirati podatke!');
            }
        }

        axios.post('students/filter-students/false', { ...docFilter })
            .then(res => {
                this.setState({ filterData: res.data, loading: false });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }

    filtersOff() {
        this.setState({
            showFilterMode: false, showFiltersOnButton: false,
        });
        return this.state.data;
    }

    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1">Korisnički računi</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">Spisak studenata
                            <Header style={IconHeader} floated="right" >
                                {this.state.showFiltersOnButton && <Button
                                    onClick={this.filtersOff}
                                    floated="left"
                                    icon
                                    labelPosition="right"
                                    color="orange"
                                    size="small"
                                    style={FiltersOnStyle}
                                >
                                    <Icon className="remove" onClick={this.filtersOff} />
                                    Filtriranje uključeno!
                                </Button>}
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic="true" floated="right" name="filter" onClick={this.activateFilter} />}
                                    content="Filtriranje podataka"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    {this.state.showFilterMode && <Segment>

                        <Filters
                            onFilterData={this.getFilterData}
                            studyPrograms={this.state.studyPrograms}
                            filtersOff={this.filtersOff}
                            noSProgram
                        />

                    </Segment>}
                    <Segment>
                        {this.getDataToRender().length ?
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                        <Table.HeaderCell>Prezime i ime</Table.HeaderCell>
                                        <Table.HeaderCell>Broj indexa</Table.HeaderCell>
                                        <Table.HeaderCell>Smjer (studijski program)</Table.HeaderCell>
                                        <Table.HeaderCell colSpan="2" />
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.getDataToRender().map((el, index) =>
                                    (<Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle">
                                            {index + 1}.
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.lastName} {el.firstName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.index}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.studyProgramName}
                                        </Table.Cell>
                                        <Table.Cell textAlign="center" colSpan="2" verticalAlign="middle">
                                            <Button
                                                basic="true"
                                                color="blue"
                                                size="small"
                                            >  Kreiranje/reset šifre
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                            : (this.state.showFiltersOnButton && !this.state.loading) ?
                                <NoFilterDataMessage />
                                : !this.state.loading ? <NoDataMessage /> : null
                        }
                        <ToastContainer hideProgressBar />
                    </Segment>

                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/AllStudents.js